<div class="page-container">
  <div class="left-section">
    <!-- Modern Flowing Decorative Elements -->
    <div class="decorative-element element-1">
      <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M40.7,-69.2C50.9,-60.6,55.9,-44.8,62.4,-29.8C68.9,-14.8,76.9,-0.6,76.4,13.4C75.9,27.4,66.9,41.2,56.1,53.2C45.3,65.2,32.7,75.4,17.8,78.5C2.9,81.6,-14.4,77.6,-28.8,70.3C-43.2,63,-54.8,52.4,-63.2,39.7C-71.6,27,-76.8,12.2,-75.1,-1.7C-73.4,-15.6,-64.8,-28.6,-54.6,-37.8C-44.4,-47,-32.6,-52.4,-20.9,-59.9C-9.2,-67.4,2.4,-77,16.5,-79.1C30.6,-81.2,47.2,-75.8,40.7,-69.2Z" 
              transform="translate(100 100)" fill="rgba(255,255,255,0.12)"/>
      </svg>
    </div>

    <div class="decorative-element element-2">
      <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M44.1,-76.3C58.2,-69.6,71.3,-59,78.9,-45.1C86.5,-31.2,88.6,-15.6,87.5,-0.6C86.4,14.3,82.1,28.6,74.7,41.5C67.3,54.4,56.8,65.8,43.7,74.3C30.6,82.8,15.3,88.3,-0.2,88.6C-15.7,88.9,-31.4,83.9,-45.1,75.8C-58.8,67.7,-70.5,56.4,-77.8,42.6C-85.1,28.8,-88,12.4,-86.7,-3.3C-85.4,-19,-79.9,-34.9,-70.6,-47.7C-61.3,-60.5,-48.2,-70.2,-34.4,-77.1C-20.6,-84,-10.3,-88.2,2.8,-92.8C15.9,-97.4,31.8,-102.4,44.1,-76.3Z" 
              transform="translate(100 100)" fill="rgba(255,255,255,0.08)"/>
      </svg>
    </div>

    <div class="decorative-element element-3">
      <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M34.6,-58.9C45.8,-51.4,56.5,-44,65.1,-33.5C73.7,-23,80.2,-9.3,78.9,3.7C77.6,16.7,68.5,29,59.1,39.7C49.7,50.4,40,59.5,28.3,64.8C16.6,70.1,2.9,71.6,-10.1,69.7C-23.1,67.8,-35.4,62.5,-46.6,54.6C-57.8,46.7,-67.9,36.2,-73.3,23.5C-78.7,10.8,-79.4,-4.1,-75.2,-17.2C-71,-30.3,-61.9,-41.6,-50.4,-49.1C-38.9,-56.6,-25,-60.3,-11.8,-61.8C1.4,-63.3,13.9,-62.6,34.6,-58.9Z" 
              transform="translate(100 100)" fill="rgba(255,255,255,0.1)"/>
      </svg>
    </div>

    <div class="decorative-element element-4">
      <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M39.3,-67.1C52.4,-61.6,65.6,-53.7,74.3,-42.1C83,-30.5,87.2,-15.3,86.8,-0.2C86.4,14.8,81.4,29.6,72.7,41.5C64,53.4,51.6,62.4,38.1,69.1C24.6,75.8,10.1,80.2,-4.1,79.9C-18.3,79.6,-32.3,74.6,-45.6,67.4C-58.9,60.2,-71.5,50.8,-78.5,38.1C-85.5,25.4,-86.9,9.4,-85.1,-6.2C-83.3,-21.8,-78.3,-37,-68.8,-48.4C-59.3,-59.8,-45.3,-67.4,-31.5,-72.5C-17.7,-77.6,-4.4,-80.2,7.4,-77.7C19.2,-75.2,38.4,-67.7,39.3,-67.1Z" 
              transform="translate(100 100)" fill="rgba(255,255,255,0.15)"/>
      </svg>
    </div>
    
    <div class="hero-content">
      <h1>Manage the essence<br>of your life digitally</h1>
      <div class="illustration-container">
        <img src="assets/images/introillustration.png" alt="Digital Life Management" class="illustration">
      </div>
    </div>
    <div class="copyright">Lex-Z 2026. All rights reserved.</div>
  </div>

  <div class="right-section">
    <div class="form-container">
      <div class="header-content">
        <div class="login-header">
          <img class="logo" src="assets/images/lex-z_logo.png" alt="Lex-Z" class="logo"/> 
        </div>
      </div>
      <h2 class="register-title">{{ otpSent ? 'Verify OTP' : 'Create your account' }}</h2>

      <form [formGroup]="registerForm">
        <!-- OTP Sent Message -->
        <div *ngIf="otpSent" class="otp-sent-message">
          <p>{{ otpSentMessage }}</p>
        </div>

        <div class="form-fields">
          <!-- Initial Registration Fields (hidden when OTP is sent) -->
          <div *ngIf="!otpSent">

            <!-- Name Fields -->
            <div class="name-fields">
              <div class="form-field">
                <input type="text" 
                  (input)="restricttextSpace($event)" 
                  (keydown.enter)="onRegisterButtonClicked()"
                  formControlName="firstName" 
                  placeholder="First Name"
                  [class.is-invalid]="submitted && f['firstName'].errors">
                <div *ngIf="submitted && f['firstName'].errors">
                  <div class="errorStyle" *ngIf="f['firstName']?.errors?.['required']">
                    First Name is required
                  </div>
                </div>
              </div>
              <div class="form-field">
                <input type="text" 
                  (input)="restricttextSpace($event)" 
                  (keydown.enter)="onRegisterButtonClicked()"
                  formControlName="lastName" 
                  placeholder="Last Name"
                  [class.is-invalid]="submitted && f['lastName'].errors">
                <div *ngIf="submitted && f['lastName'].errors">
                  <div class="errorStyle" *ngIf="f['lastName']?.errors?.['required']">
                    Last Name is required
                  </div>
                </div>
              </div>
            </div>

            <!-- Email Field -->
            <div class="form-field">
              <input 
                type="email"
                (input)="restricttextSpace($event)"
                (keydown.enter)="onRegisterButtonClicked()"
                formControlName="email"
                placeholder="Email Address"
                [class.is-invalid]="submitted && f['email'].errors"
                autocomplete="off">
              <div *ngIf="submitted && f['email'].errors">
                <div class="errorStyle" *ngIf="f['email']?.errors?.['required']">
                  Email address is required
                </div>
                <div class="errorStyle" *ngIf="f['email']?.errors?.['invalidEmail']">
                  Please enter a valid email address
                </div>
              </div>
            </div>

            <!-- Mobile Number Field -->
            <div class="form-field">
              <input 
                type="text"
                inputmode="numeric"
                (input)="onMobileInput($event)"
                (blur)="submitted && f['mobile'].updateValueAndValidity()"
                (keydown.enter)="onRegisterButtonClicked()"
                formControlName="mobile"
                placeholder="Mobile Number"
                [class.is-invalid]="submitted && f['mobile'].errors"
                autocomplete="off"
                maxlength="10">
              <div *ngIf="submitted && f['mobile'].errors">
                <div class="errorStyle" *ngIf="f['mobile']?.errors?.['required']">
                  Mobile number is required
                </div>
                <div class="errorStyle" *ngIf="f['mobile']?.errors?.['invalidMobile']">
                  Please enter a valid phone number
                </div>
              </div>
            </div>

          </div>

          <!-- OTP Input Fields (6 separate boxes) -->
          <div class="otp-input-container" *ngIf="otpSent">
            <label class="otp-label">Enter OTP</label>
            <div class="otp-boxes">
              <input
                #otp1
                type="text"
                class="otp-box"
                maxlength="1"
                inputmode="numeric"
                [(ngModel)]="otpDigits[0]"
                [ngModelOptions]="{standalone: true}"
                (input)="onOtpInput($event, 1, otp2)"
                (keydown)="onOtpKeydown($event, 1)"
                (paste)="onOtpPaste($event)"
                autocomplete="off">
              <input
                #otp2
                type="text"
                class="otp-box"
                maxlength="1"
                inputmode="numeric"
                [(ngModel)]="otpDigits[1]"
                [ngModelOptions]="{standalone: true}"
                (input)="onOtpInput($event, 2, otp3)"
                (keydown)="onOtpKeydown($event, 2)"
                autocomplete="off">
              <input
                #otp3
                type="text"
                class="otp-box"
                maxlength="1"
                inputmode="numeric"
                [(ngModel)]="otpDigits[2]"
                [ngModelOptions]="{standalone: true}"
                (input)="onOtpInput($event, 3, otp4)"
                (keydown)="onOtpKeydown($event, 3)"
                autocomplete="off">
              <input
                #otp4
                type="text"
                class="otp-box"
                maxlength="1"
                inputmode="numeric"
                [(ngModel)]="otpDigits[3]"
                [ngModelOptions]="{standalone: true}"
                (input)="onOtpInput($event, 4, otp5)"
                (keydown)="onOtpKeydown($event, 4)"
                autocomplete="off">
              <input
                #otp5
                type="text"
                class="otp-box"
                maxlength="1"
                inputmode="numeric"
                [(ngModel)]="otpDigits[4]"
                [ngModelOptions]="{standalone: true}"
                (input)="onOtpInput($event, 5, otp6)"
                (keydown)="onOtpKeydown($event, 5)"
                autocomplete="off">
              <input
                #otp6
                type="text"
                class="otp-box"
                maxlength="1"
                inputmode="numeric"
                [(ngModel)]="otpDigits[5]"
                [ngModelOptions]="{standalone: true}"
                (input)="onOtpInput($event, 6, null)"
                (keydown)="onOtpKeydown($event, 6)"
                (keydown.enter)="onRegisterButtonClicked()"
                autocomplete="off">
            </div>
            <div *ngIf="submitted && f['otp'].errors" class="text-danger">
              <div class="errorStyle" *ngIf="f['otp']?.errors?.['required']">OTP is required</div>
              <div class="errorStyle" *ngIf="f['otp']?.errors?.['pattern']">OTP must be 6 digits</div>
            </div>
          </div>
        </div>

        <!-- Resend OTP link with timer -->
        <div *ngIf="otpSent" class="resend-container">
          <span *ngIf="!canResend" class="resend-timer">
            Resend OTP in {{ resendTimer }}s
          </span>
          <a *ngIf="canResend" 
             href="javascript:void(0)" 
             class="resend-otp" 
             (click)="resendOTP()">
            Resend OTP
          </a>
        </div>

        <!-- Button Container -->
        <div class="button-container">
          <button type="button" 
                  class="login-button" 
                  (click)="onRegisterButtonClicked()">
            <span>{{ otpSent ? 'Verify OTP' : 'Send OTP' }}</span>
          </button>

          <!-- Cancel OTP button -->
          <button *ngIf="otpSent" 
                  type="button" 
                  class="cancel-button" 
                  (click)="cancelOTP()">
            <span>Cancel</span>
          </button>
        </div>

        <div class="register-prompt" *ngIf="!otpSent">
          Already have an account ? <a routerLink="/login" class="register-link">Log In</a>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- ========== Confirmation Dialog Overlay ========== -->
<div class="confirm-overlay" *ngIf="showConfirmDialog" (click)="$event.stopPropagation()">
  <div class="confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="confirmDialogTitle">
    <h3 class="confirm-title" id="confirmDialogTitle">Confirm Details</h3>
    <p class="confirm-message">
      Please confirm your email address <strong>{{ confirmEmail }}</strong> and phone number <strong>{{ confirmPhone }}</strong>.
    </p>
    <div class="confirm-actions">
      <button type="button" class="confirm-btn-secondary" (click)="onConfirmCancel()">
        No, Edit
      </button>
      <button type="button" class="confirm-btn-primary" (click)="onConfirmProceed()">
        Yes, Continue
      </button>
    </div>
  </div>
</div>